import React from 'react';

// 04-enforce.md 4.1 -- extraído de SubPanelTratos.jsx: la zona de resize del borde izquierdo,
// el banner de observaciones, el header (icono + título + subtítulo dinámico + botones de
// enlace público) y los tabs de navegación ("Parámetros" / "Outside ins" / "Vista de datos").
// Presentacional: `onChangeField` (el `handleInputChange` del container) llega por prop para
// los dos botones de enlace público, que son los únicos con efecto secundario.
const genUuidFallback = () =>
  (crypto.randomUUID ? crypto.randomUUID() : Math.random().toString(36).substring(2, 15));

const NAV_TABS = [
  { id: 'parametros', label: 'Parámetros' },
  { id: 'outside-ins', label: 'Outside ins' },
  { id: 'vista-datos', label: 'Vista de datos' },
];

const SubPanelTratosHeader = ({
  isCotiza,
  isContrato,
  isClienteNode,
  resolvedNodeSub,
  formData,
  op,
  publicUuid,
  isSaving,
  onClose,
  onResizeStart,
  activeSubTab,
  onChangeSubTab,
  onChangeField,
}) => {
  const isCotizaOrContrato = isCotiza || isContrato;
  const isSendTerminal = resolvedNodeSub.includes('send-terminal');

  const ensureUuid = () => {
    let uuid = formData.public_uuid;
    if (!uuid) {
      uuid = genUuidFallback();
      onChangeField('public_uuid', uuid);
    }
    return uuid;
  };

  const headerTitle = isClienteNode
    ? 'CLIENTE'
    : isContrato
      ? 'Contrato para terminales'
      : isCotiza
        ? 'COTIZACION para Terminales'
        : isSendTerminal
          ? 'SEND terminales'
          : `Formulario para TERMINALES - ${formData.nombre_negocio || formData.cliente_nick || op?.cliente_nick || op?.nombre_negocio || 'Sin Nombre'}`;

  const headerSubtitle = isClienteNode
    ? 'Completa la información del perfil del cliente.'
    : isSendTerminal
      ? 'Area a donde se envian las terminales fisicas.'
      : 'Completa los datos para iniciar el proceso';

  return (
    <>
      {/* Resizer Zone on the left border */}
      <div
        className="op-resizer-zone"
        style={{
          position: 'absolute',
          left: '-6px',
          top: 0,
          bottom: 0,
          width: '12px',
          cursor: 'ew-resize',
          zIndex: 1000000,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          pointerEvents: 'all'
        }}
      >
        {/* Resizer Handle */}
        <div
          className="op-resizer-handle"
          onPointerDown={onResizeStart}
          style={{
            position: 'absolute',
            bottom: '125px',
            left: '50%',
            transform: 'translateX(-50%)',
            width: '8px',
            height: '48px',
            borderRadius: 'var(--radius-sm)',
            background: 'rgba(255, 255, 255, 0)',
            transition: 'background 0.2s, opacity 0.2s',
            cursor: 'ew-resize',
            pointerEvents: 'all'
          }}
        />
      </div>
      {!!formData.observaciones && (
        <div style={{width:'100%', padding:'var(--space-3)', background:'#ef4444', color:'#fff', textAlign:'center', fontWeight:'bold', fontSize:'12px', letterSpacing:'0.5px'}}>
          TIENES : 1 OBSERVACIONES
        </div>
      )}
      <div className="op-sub-panel-header" style={{flexDirection: 'column', alignItems: 'stretch', gap: 'var(--space-4)', borderBottom: '1px solid rgba(255,255,255,0.06)', paddingBottom: 'var(--space-2)'}}>
        <div style={{display:'flex', alignItems:'flex-start', justifyContent:'space-between', width:'100%'}}>
          <div style={{display:'flex', alignItems:'center'}}>
             <div className="op-header-icon" style={isCotizaOrContrato ? {background:'rgba(249,115,22,0.15)', borderColor:'rgba(249,115,22,0.3)', color:'#f97316'} : {}}>
               {isCotizaOrContrato
                 ? <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/><polyline points="10 9 9 9 8 9"/></svg>
                 : <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle cx="9" cy="7" r="4"></circle><path d="M23 21v-2a4 4 0 0 0-3-3.87"></path><path d="M16 3.13a4 4 0 0 1 0 7.75"></path></svg>
               }
             </div>
             <div className="op-header-titles">
               <div className="op-header-title">{headerTitle}</div>
               <div className="op-header-subtitle" style={{display:'flex', alignItems:'center', gap:'var(--space-3)', marginTop:'var(--space-2)'}}>
                  {isCotizaOrContrato ? (
                    <>
                      <span>{isContrato ? 'Contrato de terminales' : 'Cotización enviada para cliente'}</span>
                      <div style={{ background: '#f97316', color: '#fff', fontSize: '9px', fontWeight: '600', padding: 'var(--space-1) var(--space-2)', borderRadius: 'var(--radius-sm)', letterSpacing: '0.5px', cursor:'pointer' }}>ENVIAR</div>
                    </>
                  ) : (
                    <>
                      <span>{headerSubtitle}</span>
                      {!publicUuid ? (
                        <div style={{display:'flex', alignItems:'center', gap:'var(--space-2)'}}>
                          <div style={{ background: '#3b82f6', color: '#fff', fontSize: '9px', fontWeight: '600', padding: 'var(--space-1) var(--space-2)', borderRadius: 'var(--radius-sm)', letterSpacing: '0.5px' }}>ENVIAR</div>
                          <button style={{ background: 'rgba(255,255,255,0.05)', border: 'none', color: 'rgba(255,255,255,0.6)', padding: 'var(--space-1)', borderRadius: 'var(--radius-sm)', cursor: 'pointer', display: 'flex' }} title="Copiar enlace público" aria-label="Copiar enlace público" onClick={(e) => {
                             e.stopPropagation();
                             const uuid = ensureUuid();
                             navigator.clipboard.writeText(`https://colonny.xyz/s/${uuid}`);
                          }}>
                            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path></svg>
                          </button>
                          <button style={{ background: formData.is_public ? 'rgba(16,185,129,0.15)' : 'rgba(239,68,68,0.15)', border: 'none', color: formData.is_public ? '#10b981' : '#ef4444', padding: 'var(--space-1)', borderRadius: 'var(--radius-sm)', cursor: 'pointer', display: 'flex' }} title={formData.is_public ? 'Enlace público activo' : 'Enlace privado'} aria-label={formData.is_public ? 'Enlace público activo' : 'Enlace privado'} onClick={(e) => {
                             e.stopPropagation();
                             ensureUuid();
                             onChangeField('is_public', !formData.is_public);
                          }}>
                             {formData.is_public
                               ? <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 9.9-1"/></svg>
                               : <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>}
                          </button>
                        </div>
                      ) : null}
                    </>
                  )}
               </div>
             </div>
          </div>
          <div style={{display:'flex', alignItems:'center', gap:'var(--space-3)'}}>
             {isSaving && <span style={{fontSize:'10px', color:'#10b981'}}>Guardando...</span>}
             <button className="op-sub-panel-close" aria-label="Cerrar" onClick={onClose}>✕</button>
          </div>
        </div>

        {/* Dynamic Navigation Tabs */}
        {!publicUuid && (
          <div style={{ display: 'flex', gap: 'var(--space-6)', marginTop: 'var(--space-1)', paddingBottom: '0' }}>
            {NAV_TABS.map(tab => {
              const isActive = activeSubTab === tab.id;
              return (
                <button
                  key={tab.id}
                  type="button"
                  onClick={() => onChangeSubTab(tab.id)}
                  style={{
                    background: 'none',
                    border: 'none',
                    color: isActive ? '#fff' : 'rgba(255,255,255,0.4)',
                    fontSize: '12px',
                    fontWeight: isActive ? '600' : '400',
                    padding: 'var(--space-2) 0',
                    cursor: 'pointer',
                    position: 'relative',
                    transition: 'color 0.2s',
                    display: 'flex',
                    alignItems: 'center',
                    outline: 'none'
                  }}
                >
                  {tab.label}
                  {isActive && (
                    <div style={{
                      position: 'absolute',
                      bottom: '-9px',
                      left: 0,
                      right: 0,
                      height: '2px',
                      background: '#f97316', // Orange line pointing to active tab
                      borderRadius: '2px',
                      zIndex: 2
                    }} />
                  )}
                </button>
              );
            })}
          </div>
        )}
      </div>
    </>
  );
};

export default SubPanelTratosHeader;
